import { API_BASE_URL, DEFAULT_HEADERS } from '../../apiConfig';

export const ProfessorService = {
  async processStudentMessage(
    activityId,
    lessonTitle,
    leader,
    studentMessage,
    studentProfile,
    courseDetails,
    notes,
    chatHistory
  ) {
    const payload = {
      agentId: 'professor',
      persona: studentProfile?.persona || null,
      activityId: activityId ?? 'unknown-activity',
      lessonTitle: lessonTitle ?? 'Untitled Lesson',
      leader: leader ?? 'Professor',
      studentMessage: studentMessage ?? '',
      studentProfile: studentProfile ?? {},
      courseDetails: courseDetails ?? {},
      notes: notes ?? '',
      chatHistory: chatHistory ?? [],
    };

    const response = await fetch(`${API_BASE_URL}/professor-chat`, {
      method: 'POST',
      headers: DEFAULT_HEADERS,
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    const professorReply = {
      sender: 'Professor',
      text: data.response,
      timestamp: new Date().toLocaleTimeString(),
    };

    return professorReply;
  },

  /**
   * Generic content generator for an activity, used for prefetch and dynamic agent calls.
   * This wraps generateNotes for Professor, but allows for future extensibility.
   * @param {Object} activity - The activity object (should contain title, id, etc.)
   * @param {Object} studentProfile - The student's profile object
   * @param {Object} courseDetails - The course details object
   * @returns {Promise<string>} - The generated notes/content
   */
  async generateContentForActivity(activity, studentProfile, courseDetails) {
    const payload = {
      agentId: 'professor',
      persona: studentProfile?.persona || null,
      // Course Parameters
      courseTitle: courseDetails?.title ?? 'Untitled Course',
      courseDescription: courseDetails?.description ?? 'No course description provided.',
      courseDifficultyLevel: courseDetails?.difficulty_level ?? 'Unknown',
      // Lesson Parameters
      lessonTitle: activity?.title ?? 'Untitled Lesson',
      lessonObjective: activity?.objective ?? 'No lesson objective provided.',
      lessonAssessment: activity?.assessment ?? 'No assessment provided.',
      // Profile Parameters
      profileName: studentProfile?.name ?? 'Anonymous',
      educationLevel: studentProfile?.education_level ?? 'Not specified',
      careerGoals: studentProfile?.career_goals ?? 'Not specified',
      interests: studentProfile?.interests ?? 'Not specified',
    };
    // All payload fields now have defaults
    return this.generateNotes(payload);
  },

  async generateNotes(payload) {
    const response = await fetch(`${API_BASE_URL}/generate-notes`, {
      method: 'POST',
      headers: DEFAULT_HEADERS,
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`API request failed: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data.notes;
  },
};
